import axios from "axios";

import { URL, getUrl } from "@api/constants";

class DevicesClient {
  getDevices(pageNum, pageSize) {
    return axios.get(getUrl(URL.GET_DEVICES_LIST), {
      params: {
        pageNum,
        pageSize
      }
    });
  }
  searchDevices(q, pageNum, pageSize) {
    return axios.get(getUrl(URL.GET_DEVICES_SEARCH), {
      params: {
        q,
        pageNum,
        pageSize
      }
    });
  }
 
  getDevice(serial) {
    return axios.get(
      getUrl(URL.GET_DEVICE, {
        serial
      })
    );
  }
  getStatuses(serials) {
    return axios.post(
      URL.GET_DEVICE_STATUS,
      serials,
    );
  }
  putDevice(serial, device) {
    return axios.put(
      getUrl(URL.PUT_DEVICE, {
        serial
      }),
      device
    );
  }
  postDevice(device) {
    return axios.post(getUrl(URL.POST_DEVICE), device);
  }
  deleteDevice(serial) {
    return axios.delete(
      getUrl(URL.DELETE_DEVICE, {
        serial
      })
    );
  }
  restoreDevice(serial) {
    return axios.patch(
      getUrl(URL.PATCH_DEVICE_RESTORE, {
        serial
      })
    );
  }
  xmlSend(serial) {
    return axios.post(
      getUrl(URL.GET_XML_FILE, {
        serial
      })
    );
  }
  getContent(serial, page, pageSize) {
    return axios.get(
      getUrl(URL.GET_DEVICE_CONTENT, {
        serial
      }),
      {
        params: {
          pageNum: page,
          pageSize: pageSize
        }
      }
    );
  }
}

export let devicesClient = new DevicesClient();



// WEBPACK FOOTER //
// ./src/api/devices.js